<template>
  <naj-modal-2
    ref="mobileVerificationModal"
    :width="350"
    :footer="true"
    :header="false"
    class="pb-40"
    @onClose="closeModal"
  >
    <v-form
      ref="verifiedMobileForm"
      class="model-container"
    >
      <v-row
        v-if="isCountDown"
        class="model-header"
      >
        <naj-input
          :type-id="formFieldType.number"
          :label="local.mobileVerificationModal.title"
          :value.sync="mobileCode"
          validates="required|max:4"
          @input="showWrongCodeMessage = false"
        ></naj-input>
      </v-row>
      <v-row
        v-if="isCountDown"
        class="timer"
      >
        <span class="timer-font">
          {{ formatTime }}
        </span>
      </v-row>
      <v-row>
        <div
          v-if="!isCountDown"
          class="alert-message"
        >
          {{ local.mobileVerificationModal.timeout }}
          <a @click="resend">إعادة الارسال</a>
        </div>
        <div
          v-if="showWrongCodeMessage && isCountDown"
          class="warning-message"
        >
          {{ local.mobileVerificationModal.wrongCodeMessage }}
        </div>
      </v-row>
    </v-form>
    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <naj-button
        v-if="isCountDown"
        @click="submit(closeNajModal)"
      >
        {{ local.common.check }}
      </naj-button>
      <naj-button
        type="button"
        color="#89743e"
        @click="closeModal"
      >
        {{
          local.common.close
        }}
      </naj-button>
    </template>
  </naj-modal-2>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');
export default {
  name: 'MobileVerificationModal',
  components: {},
  props: {
    mobileNo: { type: String },
    modalVisibility: { type: Boolean },
  },
  data() {
    return {
      timerCount: 120,
      mobileCode: {},
      showWrongCodeMessage: false,
      clearTimer: null,
    };
  },
  computed: {
    formatTime() {
      let minutes = Math.floor(this.timerCount / 60);
      let seconds = this.timerCount % 60;
      return `${minutes.toString()
        .padStart(2, '0')}:${seconds.toString()
          .padStart(2, '0')}`;
    },
    isCountDown() {
      return this.timerCount > 0;
    },
  },
  watch: {
    modalVisibility(newValue) {
      this.resetInitialData();
      if (newValue) {
        this.$refs.mobileVerificationModal.show();
        this.startTimer();
      } else {
        this.$refs.mobileVerificationModal.close();
      }
    },
  },
  mounted() { },
  methods: {
    ...mapComplaintsActions([
      'updateMobileNumber',
    ]),
    closeModal() {
      this.$emit('onClose');
    },
    resetInitialData() {
      this.timerCount = 120;
      this.verificationCodeObject = {};
      this.showWrongCodeMessage = false;
    },
    submit() {
      this.showWrongCodeMessage = false;
      this.$refs.verifiedMobileForm.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            this.updateMobileNumber(this.mobileCode, { MobileCode: '2302995457' })
              .then((data) => {
                if (data.data == true) {
                  this.toaster.success(this.local.mobileVerificationModal.successMessage);
                  this.closeModal();
                } else {
                  this.showWrongCodeMessage = true;
                }
              });
          }
        });
    },
    startTimer: function () {
      clearInterval(this.clearTimer);
      this.clearTimer = setInterval(() => {
        if (this.timerCount > 0) {
          this.timerCount--;
        }
      }, 1000);
    },
    resend() {
      this.$emit('onResend');
      this.resetInitialData();
      this.startTimer();
    },
  },
};
</script>
<style lang="scss" scoped>
.model-container {
  padding: 10px;
  padding-top: 20px;
}
.model-header {
  align-items: center;
}
.timer {
  display: flex;
  justify-content: center; /* Centers the span horizontally */
  align-items: center;
}
.timer-font {
  font-weight: 600;
  color: red;
}
.alert-message {
  width: 100%;
  margin: 10px 0;
  color: #343a40;
  font-weight: 600;
  text-align: center;
}
.warning-message {
  margin: 10px 0;
  color: red;
  font-weight: 600;
}
</style>
